import React from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';

import { NotFoundPage } from './containers/NotFoundPage/Loadable';
import { HomePageV2 } from './containers/landingPages/HomePageV2/Loadable';
import { PrivacyPolicyPage } from './containers/PrivacyPolicyPage/Loadable';
import { CertificateMintPage } from './containers/CertificateMintPage/Loadable';
import { TokenListPage } from './containers/TokenListPage/Loadable';
import { TokenDetailPage } from './containers/TokenDetailPage/Loadable';
import { DocumentationPage } from './containers/landingPages/DocumentationPage';

export function Routes() {
  const history = useHistory();
  history.listen(location => {
    (window as any).ga4?.pageview(location.pathname);
  });

  return (
    <Switch>
      <Route exact path="/privacy" component={PrivacyPolicyPage} />
      <Route exact path="/" component={HomePageV2} />
      <Route exact path="/mint" component={CertificateMintPage} />
      <Route exact path="/tokens" component={TokenListPage} />
      <Route
        exact
        path="/details/:contractAddress/:tokenId"
        component={TokenDetailPage}
      />
      <Route path="/documentation" component={DocumentationPage} />
      <Route
        path="/creators"
        component={() => {
          window.location.href = 'https://nasacademy.com/creators';
          return null;
        }}
      />

      <Route component={NotFoundPage} />

      {/* -- Todo: Neeed to remove (Obsolete pages) -- */}

      {/* <Route exact path="/comment-analysis" component={CommentAnalysisPage} />
      <Route exact path="/course-review" component={CourseReviewPage} />
      <Route exact path="/comments" component={CommentAnalysisPage} />
      <Route exact path="/linktree" component={LinktreeFeaturePage} />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/logout" component={LogoutPage} />
      <Route exact path="/signup" component={SignupPage} />
      <Route exact path="/overview" component={OverviewPage} />
      <Route exact path="/analytics" component={AnalyticsPage} />
      <Route exact path="/features" component={FeatureFeedbackPage} />
      <Route exact path="/localisation" component={LocalisationPage} />
      <Route exact path="/admin/news" component={NewsAdminPage} />
      <Route exact path="/settings" component={SettingsPage} />
      <Route exact path="/creators" component={CreatorDiscoveryPage} />
      <Route exact path="/:creator" component={AllInOneStatsPage} />
      <Route
        exact
        path="/:creator/comments"
        component={VideoSentimentAnalysisPage}
      />
      <Route exact path="/creatortools" component={CreatorTools} />
      <Route exact path="/mint-legacy" component={MintYourTokenPage} /> */}
    </Switch>
  );
}
